import Layout from "../../hocs/Layout";
import { Button, Col, Row, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const Error404 = () => {
  const navigate = useNavigate();

  return (
    <Layout>
      <div className="d-flex align-items-center justify-content-center min-vh-100 bg-light">
        <Container className="text-center">
          <Row className="justify-content-center">
            <Col md={8} lg={6}>
              <div className="bg-white p-5 rounded-4 shadow-lg">
                <h1 className="display-1 fw-bold text-primary mb-0">404</h1>
                <h2 className="h4 text-secondary mb-4">Página no encontrada</h2>
                <p className="text-muted mb-4 lead">
                  Lo sentimos, la página que intentas acceder no existe o fue movida.
                </p>
                <Button
                  variant="primary"
                  className="rounded-pill px-5 py-2 shadow-sm fw-bold"
                  onClick={() => navigate("/")}
                >
                  Volver al inicio
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
};

export default Error404;
